// extracted by mini-css-extract-plugin
export var badge = "Badge-module--badge--cq0Xi";
export var badge_grey = "Badge-module--badge_grey--3An1P";
export var badge_yellow = "Badge-module--badge_yellow--3PwcP";
export var badge_pink = "Badge-module--badge_pink--3mib2";
export var badge_purple = "Badge-module--badge_purple--1hmDl";
export var badge_green = "Badge-module--badge_green--3L6GR";
export var badge__text = "Badge-module--badge__text--HPgA8";